if (navigator.serviceWorker) {
  navigator.serviceWorker.register('/serviceworker.js', { scope: '/' })
    .then(function(reg) {
      console.log('[Companion]', 'Service worker registered!');

      // プッシュ通知の購読
      reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: window.vapidPublicKey,
      }).then(subscribeSuccess);
    });
}

var subscribeSuccess = function (subscription) {
  params = {
    endpoint: subscription.endpoint,
    p256dh: btoa(String.fromCharCode.apply(null, new Uint8Array(subscription.getKey('p256dh'))))
      .replace(/\+/g, '-').replace(/\//g, '_'),
    auth: btoa(String.fromCharCode.apply(null, new Uint8Array(subscription.getKey('auth'))))
      .replace(/\+/g, '-').replace(/\//g, '_')
  };

  $.ajax({
    type: 'POST',
    url: '/api/v1/devices',
    data: params
  }).fail(function (e) {
    console.log(e)
  });
}